import { useMutation } from '@tanstack/react-query'
import { calculateRefundAmountUpdate } from '@/api/returns-api'
import { ReturnsApiCalculateUpdateAmountRequest } from '@itsrever/rever-api'

const calculateRefundAmount = async (
  req: ReturnsApiCalculateUpdateAmountRequest
) => {
  const data = await calculateRefundAmountUpdate(req)

  return data
}

export const useCalculateRefundAmount = () => {
  return useMutation({
    mutationFn: calculateRefundAmount
  })
}
